module.exports = __webpack_public_path__ + "static/media/everlife.ba7407b4.svg";